import {Button, Dialog, icons} from '@superweb/ui'
import type {SuggestObject} from '@yandex-delivery/api/model/suggest'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {Point} from '@yandex-delivery/core/types'
import {useState} from 'react'

import {MapControl, MapControls} from '../../../../../../../components/map'
import {TariffsMap} from '../../../../../../../components/TariffsMap'
import type {MapPoint} from '../../../../../../../components/TariffsMap/types'
import {useConfig} from '../../../../../../../config'
import {AddressSuggest} from '../../AddressSuggest'
import styleClasses from './classes.module.css'

type Props = {
  opened: boolean
  polygon?: Point[]
  onBack: VoidFunction
}

export function FullScreenPolygonMap({opened, polygon, onBack}: Props) {
  const [point, setPoint] = useState<MapPoint>()

  const i18n = useI18n()
  const {location} = useConfig()

  const changeHandler = (suggest?: SuggestObject, inputValue?: string) => {
    if (inputValue?.length === 0 || !suggest?.position) {
      setPoint(undefined)
      return
    }

    const suggestPoint: MapPoint = {
      title: suggest?.title.text,
      coordinates: suggest?.position,
      id: suggest.placeId,
    }

    setPoint(suggestPoint)
  }

  const closeMapHandler = () => {
    onBack()
    setPoint(undefined)
  }

  if (!opened) return

  return (
    <Dialog
      render={() => (
        <div className={styleClasses.modal}>
          <TariffsMap controlsPosition="left" point={point} polygon={polygon}>
            <MapControls position="top left">
              <MapControl transparent>
                <Button
                  icon={icons.ArrowLeft}
                  onPress={closeMapHandler}
                  shape="squircle"
                  size="s"
                  text={i18n('tariffs-v3.tariff-info.map.go-back', 'Назад')}
                  view="floating"
                />
              </MapControl>
            </MapControls>
          </TariffsMap>
          <div className={styleClasses.suggestContainer}>
            <AddressSuggest
              location={location}
              onChange={changeHandler}
              placeholder={i18n('tariffs-v3.tariff-info.map.suggest.placeholder', 'Поиск по адресу')}
            />
          </div>
        </div>
      )}
      size="xl"
      variant="slideover"
    />
  )
}
